import { render } from "./culturalMain.vue?vue&type=template&id=20fdc124&scoped=true"
import script from "./culturalMain.vue?vue&type=script&lang=js"
export * from "./culturalMain.vue?vue&type=script&lang=js"

import "./culturalMain.vue?vue&type=style&index=0&id=20fdc124&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fdc124"]])

export default __exports__